import Config from 'config';
import segmentAnalyticsInit from './analytics';
import { getBusinessId } from '../helpers/query';
// @ts-ignore
import { auth } from '@my-account/tools';
import { removeQueryString } from '../helpers/tools';
import { ETelemetryNames } from 'telemetry/type';

declare global {
    interface Window {
        analytics?: SegmentAnalytics.AnalyticsJS;
    }
}

export const analytics = (): SegmentAnalytics.AnalyticsJS => {
    if (window.analytics === undefined) {
        throw new Error('bug: call initSegment() beforehand');
    }
    return window.analytics;
};

const getDefaultContext = () => ({
    category: 'SME', // for google
    productFamily: 'SME', // for analysts
    domain: '',
    feature: '',
    sourceSystem: 'MyAccount',
    businessId: getBusinessId(),
    userId: auth.getUser()?.userId,
    label: '',
    timestamp: new Date(Date.now()).toISOString(),
    url: removeQueryString(window.location.href),
});

const getCustomisedContext = () => ({
    context: {
        page: {
            referrer: removeQueryString(window.document.referrer),
            search: '',
            url: removeQueryString(window.location.href),
        },
    },
});

export const page = (name: string, properties: object) => {
    analytics().page(name, { ...getDefaultContext(), ...properties }, getCustomisedContext());
};

export const identify = (name: string) => {
    analytics().identify(name, getDefaultContext(), getCustomisedContext());
};

type TrackProperties = {
    action: string;
    label?: string;
    createData?: object;
    clickData?: object;
    viewData?: object;
    editData?: object;
};

export const track = (name: ETelemetryNames, properties?: TrackProperties) => {
    analytics().track(
        name,
        { ...getDefaultContext(), ...properties },
        { context: { groupId: getBusinessId(), ...getCustomisedContext().context } },
    );
};

export const group = (name: string) => {
    analytics().group(name, getDefaultContext(), getCustomisedContext());
};

const trackRefreshPage = () => {
    if (!window.location.pathname.startsWith('/paymentProfile')) {
        return;
    }
    const BROWSER_RELOAD_TYPE = 1;
    if (window.performance?.navigation?.type === BROWSER_RELOAD_TYPE) {
        track(ETelemetryNames.PaymentProfile, { action: 'RefreshPage' });
    }
};

export const initSegment = (init = segmentAnalyticsInit) => {
    init();
    if (
        window.analytics &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        !((window.analytics as unknown) as any).initialize &&
        Config.SEGMENT_WRITE_KEY?.length > 0
    ) {
        window.analytics.load(Config.SEGMENT_WRITE_KEY);
        trackRefreshPage();
    }
};
